import React from "react";
import cx from "classnames";
import s from "./Styles.module.scss";

export const WizardIndicator = () => (
  <div className={cx("me-1", s.wizard)}>
    <div className={cx(s.wizardIndicator)}></div>
  </div>
);
